import { GenericLabel } from '@com-delta-idp/mnx-utils';
import { LevelType, TierType } from './tier.types';

export interface Tier extends GenericLabel {
  level: LevelType;
  name: TierType;
}
